module.exports = __webpack_public_path__ + "static/frn-wlc-ah-plural-white.c27d0abe.svg";